/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SettingsInputs */

const th_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การตั้งค่า`)
};

const en_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

const ja_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定`)
};

const zh_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置`)
};

const es_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes`)
};

const pt_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações`)
};

const id_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengaturan`)
};

const fr_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réglages`)
};

const tl_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga setting`)
};

const vi_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thiết lập`)
};

const ko_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설정`)
};

const de_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen`)
};

const ru_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки`)
};

const tr_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayarlar`)
};

const it_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni`)
};

const pl_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustawienia`)
};

const uk_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Налаштування`)
};

const hi_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग्स`)
};

const ar_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإعدادات`)
};

const ms_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetapan`)
};

const bn_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সেটিংস`)
};

const zh_tw2_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定`)
};

const zh_hk2_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定`)
};

const ur_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترتیبات`)
};

const fa_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنظیمات`)
};

const sw_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mipangilio`)
};

const nl_settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instellingen`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {SettingsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const settings = /** @type {((inputs?: SettingsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SettingsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_settings(inputs)
	if (locale === "ja") return ja_settings(inputs)
	if (locale === "zh") return zh_settings(inputs)
	if (locale === "es") return es_settings(inputs)
	if (locale === "pt") return pt_settings(inputs)
	if (locale === "id") return id_settings(inputs)
	if (locale === "fr") return fr_settings(inputs)
	if (locale === "tl") return tl_settings(inputs)
	if (locale === "vi") return vi_settings(inputs)
	if (locale === "ko") return ko_settings(inputs)
	if (locale === "de") return de_settings(inputs)
	if (locale === "ru") return ru_settings(inputs)
	if (locale === "tr") return tr_settings(inputs)
	if (locale === "it") return it_settings(inputs)
	if (locale === "pl") return pl_settings(inputs)
	if (locale === "uk") return uk_settings(inputs)
	if (locale === "hi") return hi_settings(inputs)
	if (locale === "ar") return ar_settings(inputs)
	if (locale === "ms") return ms_settings(inputs)
	if (locale === "bn") return bn_settings(inputs)
	if (locale === "zh-TW") return zh_tw2_settings(inputs)
	if (locale === "zh-HK") return zh_hk2_settings(inputs)
	if (locale === "ur") return ur_settings(inputs)
	if (locale === "fa") return fa_settings(inputs)
	if (locale === "sw") return sw_settings(inputs)
	if (locale === "nl") return nl_settings(inputs)
	return en_settings(inputs)
});